<template>
  <div class="wedding-abc">
    <v-card
      v-for="(letter, i) in abc"
      :key="i"
      class="card mx-auto"
      lighten
      raised
    >
      <v-card-title>
        <span class="headline font-weight-bold font-color">{{
          letter.letter
        }}</span
        ><span class="font-weight-light">{{ letter.word.substring(1) }}</span>
      </v-card-title>

      <v-card-text class="outline">
        {{ letter.text }}
      </v-card-text>
    </v-card>
  </div>
</template>
<style scoped>
.wedding-abc {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.font-color {
  color: #1acdff;
}
.card {
  max-width: 600px;
  width: 100%;
  margin-bottom: 20px;
}
</style>
<script>
export default {
  name: "ourStory",
  data: () => ({
    abc: [
      {
        letter: "A",
        word: "Ankunft",
        text: "Ankunft bitte rechtzeitig um 14:00 Uhr an der Kirche!"
      },
      {
        letter: "B",
        word: "Brautentführung",
        text: "Brautentführung möchten wir nicht auf unserer Hochzeit."
      },
      {
        letter: "C",
        word: "Can't",
        text: "Can’t stop loving you – und aus diesem Grund heiraten wir!"
      },
      {
        letter: "D",
        word: "Dresscode",
        text: "Dresscode ist festlich/elegant."
      },
      {
        letter: "E",
        word: "Ende",
        text: "Ende der Feier - Unsere Feier endet um 03:00 Uhr"
      },
      {
        letter: "F",
        word: "Fragen",
        text: "Fragen? Dann meldet euch bei den Trauzeugen."
      },
      {
        letter: "G",
        word: "Geldgeschenke",
        text: "Geldgeschenke werden bevorzugt."
      },
      {
        letter: "H",
        word: "Haustiere",
        text: "Haustiere sind auf unserer Feier unerwünscht."
      },
      {
        letter: "I",
        word: "Ich",
        text: "Ich und Du – daraus wird bald ein Wir."
      },
      {
        letter: "J",
        word: "Ja",
        text: "Ja – möchten wir beide endlich vor euch allen sagen."
      },
      {
        letter: "K",
        word: "Küssen",
        text: "Küssen werden wir uns nicht nur nach dem Ja-Wort."
      },
      {
        letter: "L",
        word: "Liebe",
        text: "Liebe wird den ganzen Tag zu spüren sein."
      },
      {
        letter: "M",
        word: "Menü",
        text: "Menü bleibt noch geheim!"
      },
      {
        letter: "N",
        word: "Niemand",
        text: "Niemand wird an diesem Tag hungern müssen."
      },
      {
        letter: "O",
        word: "Originelle",
        text: " Originelle Ideen sind immer willkommen."
      },
      {
        letter: "P",
        word: "Programmpunkte",
        text: "Programmpunkte bitte mit den Trauzeugen rechtzeitig besprechen!"
      },
      {
        letter: "Q",
        word: "Quellwasser",
        text:
          "Quellwasser darf gerne immer wieder zwischen den alkoholhaltigen Getränken getrunken werden, damit ihr euch auch am nächsten Tag an alle Momente unserer Hochzeit erinnern könnt."
      },
      {
        letter: "R",
        word: "Rauchen",
        text: "Rauchen ist im Hof möglich."
      },
      {
        letter: "S",
        word: "Spiele",
        text: "Spiele sind nicht so unser Ding."
      },
      {
        letter: "T",
        word: "Trauzeugen",
        text: "Trauzeugen sind Marlene Breuer und Frank Sommer."
      },
      {
        letter: "U",
        word: "Und",
        text: "Und eins ist klar - wer nicht zusagt hat keinen Sitzplatz"
      },
      {
        letter: "V",
        word: "Vegetarier",
        text:
          "Vegetarier, Veganer und Intoleranzen – bitte bei Zusage anmerken!"
      },
      {
        letter: "W",
        word: "Weiß",
        text: "Weiß, Creme und Rosa sind an diesem Tag nur für die Braut!"
      },
      {
        letter: "X",
        word: "X-Beine",
        text: "X-Beine sind kein Grund um nicht zu Tanzen!"
      },
      {
        letter: "Y",
        word: "Yeah",
        text: "Yeah, wir wagen den nächsten Schritt!"
      },
      {
        letter: "Z",
        word: "Zimmer",
        text:
          "Zimmer: Falls ihr eine Übernachtungsmöglichkeit benötigt, können wir euch das Hotel Lamm empfehlen und ist gleich neben der Feierlocation! Wendet euch an uns, wir haben bereits günstig Zimmer reserviert."
      }
    ]
  })
};
</script>
